export default __webpack_public_path__ + "static/media/dribbble.e58c38f6.png";